<template>
  <a href="javascript:void(0);" @click="openLink" v-if="hasXeroAccess">
    Open Xero Invoice
  </a>
</template>

<script>
import gql from 'graphql-tag'
import { lowerCaseFirstLetter } from '../util/string'

export default {
  name: 'XeroLink',
  props: ['id', 'type'],
  computed: {
    gqlQueryName () {
      return lowerCaseFirstLetter(this.type)
    },
    hasXeroAccess () {
      return this.currentAccount && this.currentAccount.roles.includes('xeroAccess')
    },
    currentAccount () {
      return this.$store.state.auth.currentAccount
    }
  },
  methods: {
    async openLink () {
      let order = await this.$apollo.query({
        query: gql`
          query ${this.gqlQueryName} ($id: ID!) {
            ${this.gqlQueryName} (id: $id) {
              id
              xeroInvoiceDeepLink
            }
          }
        `,
        variables: {
          id: this.id
        },
        fetchPolicy: 'network-only'
      })
      // const win = window.open(order?.data[`${this.gqlQueryName}`]?.xeroInvoiceDeepLink, '', 'resizable,scrollbars,status');
      const win = window.open(order?.data[this.gqlQueryName]?.xeroInvoiceDeepLink, '', 'resizable,scrollbars,status');
      win.focus()
    }
  }
}
</script>

<style scoped>

</style>
